/**
 * Permission Constants
 * Define all permissions matching the Digitimax API
 * Convention: resource.action
 */

export const PERMISSIONS = {
  // Users
  USERS_VIEW: 'users.view',
  USERS_CREATE: 'users.create',
  USERS_EDIT: 'users.edit',
  USERS_DELETE: 'users.delete',

  // Products
  PRODUCTS_VIEW: 'products.view',
  PRODUCTS_CREATE: 'products.create',
  PRODUCTS_EDIT: 'products.edit',
  PRODUCTS_DELETE: 'products.delete',

  // Categories
  CATEGORIES_VIEW: 'categories.view',
  CATEGORIES_CREATE: 'categories.create',
  CATEGORIES_EDIT: 'categories.edit',
  CATEGORIES_DELETE: 'categories.delete',

  // Attributes
  ATTRIBUTES_VIEW: 'attributes.view',
  ATTRIBUTES_CREATE: 'attributes.create',
  ATTRIBUTES_EDIT: 'attributes.edit',
  ATTRIBUTES_DELETE: 'attributes.delete',

  // Orders
  ORDERS_VIEW: 'orders.view',
  ORDERS_MANAGE: 'orders.manage',

  // Coupons
  COUPONS_VIEW: 'coupons.view',
  COUPONS_CREATE: 'coupons.create',
  COUPONS_DELETE: 'coupons.delete',

  // Special Sales
  SPECIAL_SALES_VIEW: 'special-sales.view',
  SPECIAL_SALES_CREATE: 'special-sales.create',
  SPECIAL_SALES_UPDATE: 'special-sales.update',
  SPECIAL_SALES_DELETE: 'special-sales.delete',

  // Article Categories
  ARTICLE_CATEGORIES_VIEW: 'article-categories.view',
  ARTICLE_CATEGORIES_CREATE: 'article-categories.create',
  ARTICLE_CATEGORIES_EDIT: 'article-categories.edit',
  ARTICLE_CATEGORIES_DELETE: 'article-categories.delete',

  // Articles
  ARTICLES_VIEW: 'articles.view',
  ARTICLES_CREATE: 'articles.create',
  ARTICLES_EDIT: 'articles.edit',
  ARTICLES_DELETE: 'articles.delete',

  // Reviews
  REVIEWS_VIEW: 'reviews.view',
  REVIEWS_MANAGE: 'reviews.manage',

  // Addresses
  ADDRESSES_VIEW: 'addresses.view',
  ADDRESSES_CREATE: 'addresses.create',
  ADDRESSES_EDIT: 'addresses.edit',
  ADDRESSES_DELETE: 'addresses.delete',

  // Cart
  CART_VIEW: 'cart.view',
  CART_MANAGE: 'cart.manage'
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

/**
 * Role Constants
 * Define all roles matching the Digitimax API
 */
export const ROLES = {
  ADMIN: 'Admin',
  PRODUCT_MANAGER: 'ProductManager',
  SUPPORT: 'Support',
  USER: 'User',
  GUEST: 'Guest'
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];
